import PropTypes from "prop-types";

export const SliderComponentTypes = {
    defaultValue: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    thumb: PropTypes.bool,
    marks: PropTypes.bool,
    customMarks: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.node.isRequired
    })),
    disabled: PropTypes.bool,
    valueLabelDisplay: PropTypes.oneOf(['auto', 'on', 'off']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    valueText: PropTypes.func,
    onChange: PropTypes.func,
    customColor: PropTypes.string,
  };